import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth.reducer';
import globalReducer from './global.reducer';
import nativeReducer from './native.reducer';
import auraReducer from './aura.reducer';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    global: globalReducer,
    native: nativeReducer,
    aura: auraReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['global.activeModal'],
      },
    }),
});

export default store;
